// SoundEffects.js
const clickSound = new Audio('/sounds/Blow.mp3'); // Ensure this file exists in your public folder

export const playClickSound = () => {
    clickSound.currentTime = 0; // Reset to start for rapid clicking
    clickSound.play().catch(e => console.warn("Audio playback prevented:", e));
};